// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import mixins from './mixins'
import store from './store/'
import 'bootstrap'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css'
import Vue2TouchEvents from 'vue2-touch-events'
import VueI18n from 'vue-i18n'
import VueMaterialIcon from 'vue-material-icon'

Vue.mixin(mixins)
Vue.use(Vuesax, {
  theme: {
    colors: {
      'primary': '#4d82e9',
      'secondary': '#81A9F8',
      'accent': '#ffb84d'
    }
  }
})
Vue.use(Vue2TouchEvents)
Vue.use(VueI18n)
Vue.component('icon', Icon)
Vue.component(VueMaterialIcon.name, VueMaterialIcon)
Vue.config.productionTip = false

const messages = {
  th: {
    message: {
      error_unknown: 'เกิดข้อผิดพลาด',
      error_connection: 'เกิดข้อผิดพลาดทางการเชื่อมต่อ',
      msg_search: 'อยากไปไหน?',
      msg_result: 'ผลการค้นหา',
      current_location: 'ตำแหน่งปัจจุบัน',
      custom_location: 'ตำแหน่งกำหนดเอง',
      sender_location: 'ตำแหน่งผู้ส่ง',
      logout: 'ออกจากระบบ',
      go_place: 'ไปที่นี่',
      minute: 'นาที',
      minutes: 'นาที',
      hour: 'ชม.',
      hours: 'ชม.',
      baht: 'บาท',
      km: 'กม.',
      meter: 'ม.',
      walk: 'เดิน',
      poi_list: 'แสดงป้ายใกล้ๆ',
      success: 'สำเร็จ',
      click_detail: 'คลิกเพื่อดูรายละเอียด',
      type_to_search: 'เริ่มพิมพ์เพื่อค้นหา',
      link_copied: 'Link copied to clipboard',
      app_promotional_modal: {
        'title': 'สัมผัสประสบการณ์ที่ดียิ่งขึ้นบนแอป นำทาง',
        'detail': 'ติดตามตำแหน่งได้แบบเรียลไทม์ พร้อมรับการแจ้งเตือนเฉพาะคุณ เพื่อการเดินทางที่ราบรื่นยิ่งขึ้น',
        'stay': 'อยู่ต่อบนเว็บไซต์'
      },
      home: {
        title: 'ป้ายรถเมล์ หรือ สถานีใกล้ๆ',
        no_results_msg: 'ไม่มีสถานีใกล้ๆ'
      },
      place: {
        directions: 'เส้นทาง',
        call: 'ติดต่อ',
        save: 'บันทึก'
      },
      trip_list: {
        search_placeholder: 'ค้นหาด้วยชื่อต้นทาง, ปลายทาง, หมายเลขรถ'
      },
      search: {
        title: 'ค้นหา',
        station_tab_text: 'ป้าย/สถานี',
        route_tab_text: 'สาย',
        msg_search: 'ค้นหา',
        no_results_msg: 'ไม่พบผลการค้นหา'
      },
      bus: {
        stops: 'จุดจอด',
        details: 'ข้อมูล',
        booking: 'จองตั๋ว',
        search_placeholder: 'ค้นหา GPS ด้วยเลขทะเบียนรถ',
        line: 'สาย',
        wheelchair_accessible: 'รองรับ wheelchair',
        no_wheelchair_accessible: 'ไม่รองรับ wheelchair',
        no_results_msg: 'ไม่มีรายละเอียด',
        menu: 'ค้นหาข้อมูลสาย',
        title: 'ข้อมูลสายรถเมล์',
        msg_search: 'ค้นหาสายรถเมล์',
        approach: 'ใกล้ถึง',
        arrive: 'มาถึงในอีก'
      },
      favorite: {
        title: 'สถานที่โปรด',
        no_results_msg: 'ไม่มีรายการที่ชื่นชอบ'
      },
      landmark: {
        title: 'สถานที่สำคัญ',
        no_results_msg: 'ไม่มีสถานที่สำคัญ'
      },
      traffic: {
        title: 'ข้อมูลวิเคราะห์',
      },
      landmarkpoi: {
        no_results_msg: 'ไม่มีสถานที่สำคัญใกล้ๆ'
      },
      event: {
        title: 'เหตุการณ์',
        no_results_msg: 'ไม่มีเหตุการณ์'
      },
      announce: {
        title: 'รายงานเหตุการณ์',
        category: 'ประเภท',
        topic: 'หัวข้อ',
        description: 'รายละเอียด',
        report: 'แจ้ง',
        cate: [
          { text: 'รถเสีย', value: 1 },
          { text: 'ก่อสร้าง', value: 2 },
          { text: 'อุบัติเหตุ', value: 3 },
          { text: 'ฝนตก', value: 5 },
          { text: 'น้ำท่วม', value: 6 },
          { text: 'การชุมนุม', value: 7 },
          { text: 'ข่าวประกาศ', value: 8 },
          { text: 'ด่านตรวจ', value: 9 },
          { text: 'รถติด', value: 10 },
          { text: 'จิปาถะ', value: 11 },
          { text: 'ระวัง', value: 12 },
          { text: 'การจัดงาน', value: 13 },
          { text: 'ลดราคา', value: 14 },
          { text: 'เพลิงไหม้', value: 15 }
        ],
        upload_img: 'อัพโหลดรูปภาพ'
      },
      news: {
        title: 'ประชาสัมพันธ์',
        no_results_msg: 'ไม่มีข่าวประชาสัมพันธ์',
        read_more: 'อ่านเพิ่มเติม'
      },
      search_route: {
        source_title: 'จุดเริ่มต้น',
        destination_title: 'ไปที่นี่',
        history: 'ประวัติการค้นหา',
        select_map: 'เลือกจากแผนที่',
        pin_location: 'เลือกจากแผนที่',
        select_mode: 'วิธีเดินทาง',
        refresh: 'ขอเส้นทาง',
        calendar: { ok: 'ตกลง', cancel: 'ยกเลิก', reset: 'เดินทางตอนนี้' },
        mode: [
          { value: 'walk', text: 'เดิน' },
          { value: 'bus', text: 'รถเมล์' },
          { value: 'train', text: 'รถไฟ' },
          { value: 'metro', text: 'รถไฟฟ้า' },
          { value: 'ferry', text: 'เรือ' }
        ],
        sort: [
          { text: 'ดีที่สุด', value: 'best' },
          { text: 'เรียงตามเวลา', value: 'time' },
          { text: 'เรียงตามราคา', value: 'price' },
          { text: 'เรียงตามระยะทาง', value: 'distance' }
        ],
        car: 'รถยนต์',
        estimate: 'ประมาณ',
        expense: 'ค่าใช้จ่าย',
        taxi: 'แท็กซี่/อื่นๆ',
        taxi_fee: 'มีค่าแท็กซี่/อื่นๆ',
        no_suggests_msg: 'ไม่พบผลลัพธ์การค้นหา',
        no_results_msg: 'ไม่พบผลการค้นหา',
        approximate: '(ประมาณ)',
        no_current_location: 'ไม่สามารถระบุตำแหน่งปัจจุบันได้ กรุณาอนุญาตให้เข้าถึงตำแหน่งที่ตั้งของคุณ',
        please_select_destination: 'กรุณาเลือกจุดปลายทาง'
      },
      route: {
        source: 'ตำแหน่งเริ่มต้น',
        destination: 'ถึงจุดหมาย',
        take_taxi: 'ขึ้นแท็กซี่/อื่นๆ',
        wait: 'รอรถ',
        walk: 'เดินอีก'
      },
      setting: {
        title: 'ตั้งค่า',
        language: 'ภาษา',
        ui_language: 'ภาษาของแอปพลิเคชัน',
        map_language: 'ภาษาของแผนที่',
        default: 'ค่าเริ่มต้น',
        max_walk_distance: 'ระยะการเดินไม่เกิน',
        title_walk: 'Walking distance',
        placeholder_walk: 'Enter distance',
        wheelchair: 'ใช้เก้าอี้รถเข็น',
        delete_search_history: 'ลบประวัติการค้นหา',
        delete: 'ลบ',
        cancel: 'ยกเลิก',
        map_layer: 'Layer แผนที่',
        layers: [
          { value: longdo.Layers.LIGHT_POI.name(), text: 'ธรรมดา' },
          { value: longdo.Layers.TRAFFIC.name(), text: 'จราจร' }
        ]
      },
      about: {
        title: 'เกี่ยวกับ',
        otp_name: 'สำนักงานนโยบายและแผนการขนส่งและจราจร <br /> กระทรวงคมนาคม'
      },
      support: {
        title: 'ช่วยเหลือ'
      },
      feedback: {
        title: 'ติชม'
      },
      opendata: {
        title: 'Open Data'
      },
      privacy: {
        title: 'Privacy Policy'
      },
      login: {
        title: 'เข้าสู่ระบบ',
        login_with_line: 'เข้าสู่ระบบด้วย LINE',
        login_with_facebook: 'เข้าสู่ระบบด้วย FACEBOOK',
        success: 'เข้าสู่ระบบสำเร็จ',
        error: 'เกิดข้อผิดพลาด',
        fb_error:
          'การเข้าสู่ระบบด้วย Facebook ถูกปิดกั้นจากการตั้งค่าความเป้นส่วนตัว',
        line_connect: 'กำลังเชื่อมต่อ LINE ...',
        fb_connect: 'กำลังเชื่อมต่อ FACEBOOK ...'
      }
    }
  },
  en: {
    message: {
      error_unknown: 'Unknown error',
      error_connection: 'Connection error',
      msg_search: 'Where to go?',
      msg_result: 'Search results',
      current_location: 'Current location',
      custom_location: 'Custom location',
      sender_location: "Sender's location",
      logout: 'Logout',
      go_place: 'Move to',
      minute: 'min.',
      minutes: 'min.',
      hour: 'hr.',
      hours: 'hr.',
      baht: 'baht',
      km: 'km.',
      meter: 'm.',
      walk: 'Walk',
      poi_list: 'Nearby stops',
      success: 'Successfully',
      click_detail: 'Click for more details',
      type_to_search: 'Start typing to search',
      link_copied: 'Link copied to clipboard',
      app_promotional_modal: {
        'title': 'Experience Namtang on the App',
        'detail': 'Get real-time live tracking and personalized alerts for a smoother journey.',
        'stay': 'Stay on Website'
      },
      home: {
        title: 'Nearby stops, stations',
        no_results_msg: 'No near bus station found.'
      },
      place: {
        directions: 'Directions',
        call: 'Call',
        save: 'Save'
      },
      trip_list: {
        search_placeholder: 'Origin, destination, or route'
      },
      search: {
        title: 'Search',
        station_tab_text: 'STOP/STATION',
        route_tab_text: 'ROUTE',
        msg_search: 'Search',
        no_results_msg: 'No result found.'
      },
      bus: {
        stops: 'STOPS',
        details: 'DETAIL',
        booking: 'Book Ticket',
        search_placeholder: 'Search for GPS by license plate',
        line: 'LINE',
        wheelchair_accessible: 'Wheelchair accessible',
        no_wheelchair_accessible: 'No wheelchair accessible',
        no_results_msg: 'No bus detail found.',
        menu: 'Route Info',
        title: 'Bus routes',
        msg_search: 'Search bus routes',
        approach: 'Approaching',
        arrive: 'Approaching in'
      },
      favorite: {
        title: 'Favorite places',
        no_results_msg: 'No favorite found.'
      },
      landmark: {
        title: 'Important places',
        no_results_msg: 'No landmark found.'
      },
      traffic: {
        title: 'Traffic analysis',
      },
      landmarkpoi: {
        no_results_msg: 'No landmark found.'
      },
      event: {
        title: 'Events',
        no_results_msg: 'No event found.'
      },
      announce: {
        title: 'Report events',
        category: 'Category',
        topic: 'Topic',
        description: 'Detail',
        report: 'Report',
        cate: [
          { text: 'Car break down', value: 1 },
          { text: 'Construction', value: 2 },
          { text: 'Accident', value: 3 },
          { text: 'Rain', value: 5 },
          { text: 'Flood', value: 6 },
          { text: 'Crowd', value: 7 },
          { text: 'Information', value: 8 },
          { text: 'Check point', value: 9 },
          { text: 'Traffic jam', value: 10 },
          { text: 'MISC.', value: 11 },
          { text: 'Warning', value: 12 },
          { text: 'Event', value: 13 },
          { text: 'Sale', value: 14 },
          { text: 'Fire', value: 15 }
        ],
        upload_img: 'Upload image'
      },
      news: {
        title: 'Announcements',
        no_results_msg: 'No announcements',
        read_more: 'Read more'
      },
      search_route: {
        source_title: 'Source',
        destination_title: 'Move to',
        history: 'Search history',
        select_map: 'Select from map',
        pin_location: 'Pin Location',
        select_mode: 'Transit Method',
        refresh: 'Refresh route',
        calendar: { ok: 'OK', cancel: 'CANCEL', reset: 'DEPART NOW' },
        mode: [
          { value: 'walk', text: 'Walk' },
          { value: 'bus', text: 'bus' },
          { value: 'train', text: 'Train' },
          { value: 'metro', text: 'Metro' },
          { value: 'ferry', text: 'Ferry' }
        ],
        sort: [
          { text: 'Best route', value: 'best' },
          { text: 'Sort by time', value: 'time' },
          { text: 'Sort by price', value: 'price' },
          { text: 'Sort by distance', value: 'distance' }
        ],
        car: 'Car',
        estimate: 'estimate',
        expense: 'Expense',
        taxi: 'Taxi/Others',
        taxi_fee: 'Taxi/Others fee',
        no_suggests_msg: 'No suggest found.',
        no_results_msg: 'No result found.',
        approximate: '(Approx.)',
        no_current_location: 'Current location cannot be retrieved. Please allow location access',
        please_select_destination: 'Please select your destination'
      },
      route: {
        source: 'Start Location',
        destination: 'Destination',
        go: 'to',
        take_taxi: 'Take a Taxi/Others',
        wait: 'Arrive in',
        walk: 'Walk'
      },
      setting: {
        title: 'Settings',
        language: 'Language',
        ui_language: 'UI Language',
        map_language: 'Map Language',
        default: 'Default',
        max_walk_distance: 'Max walking distance',
        title_walk: 'Walking distance',
        placeholder_walk: 'Enter distance',
        wheelchair: 'Using wheelchair',
        delete_search_history: 'Clear all search history',
        delete: 'Clear',
        cancel: 'Cancel',
        map_layer: 'Map Layer',
        layers: [
          { value: longdo.Layers.LIGHT_POI.name(), text: 'Normal' },
          { value: longdo.Layers.TRAFFIC.name(), text: 'Traffic' }
        ]
      },
      about: {
        title: 'About',
        otp_name: 'สำนักงานนโยบายและแผนการขนส่งและจราจร <br /> กระทรวงคมนาคม'
      },
      support: {
        title: 'Support'
      },
      feedback: {
        title: 'Feedback'
      },
      opendata: {
        title: 'Open Data'
      },
      privacy: {
        title: 'Privacy Policy'
      },
      login: {
        title: 'LOG IN',
        login_with_line: 'Login via LINE',
        login_with_facebook: 'Login via FACEBOOK',
        success: 'Login Successful.',
        error: 'Login unsuccessful.',
        fb_error: 'Login via FACEBOOK is blocked from privacy settings.',
        line_connect: 'Connecting with LINE ...',
        fb_connect: 'Connecting with FACEBOOK ...'
      }
    }
  }
}

var i18n = new VueI18n({
  locale: 'th', // set locale
  messages // set locale messages
})

/* eslint-disable no-new */
var app = new Vue({
  i18n: i18n,
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App />'
})
